import React, { useEffect } from 'react';
import TitlePage from '../../components/TitlePage/TitlePage';
import Introduction from './components/Introduction/Introduction';
import Methodology from './components/Methodology/Methodology';
import Support from './components/Support/Support';
import './AboutPage.scss';
import { Helmet } from 'react-helmet-async';
import { baseStrapiURL, baseURL } from '../../services/config';
import { useContentQuery } from '../../services/strapi/hooks';
import Loading from '../../components/Loading/Loading';
import { useQueryClient } from '@tanstack/react-query';
import Error404Page from '../Error404Page/Error404Page';

const AboutPage = () => {

    const strapiPage = 'about';

    const queryClient = useQueryClient();

    // Utilisation du hook personnalisé pour récupérer les données
    const { data: strapiData, isLoading, error } = useContentQuery(strapiPage);

    // Obtenir les données mises en cache ou les données actuelles
    const displayData = strapiData || queryClient.getQueryData(['strapi-content', strapiPage]);

    // N'afficher le chargement que si les données ne sont pas disponibles
    const showLoading = isLoading && !displayData;

    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    if (showLoading) return <Loading />;
    if (!displayData || displayData.length === 0 || error) return <Error404Page />;

    return (
        <div className="about-page">
            <Helmet>
                {/* Open Graph (utilisé par Facebook, LinkedIn, etc.) */}
                <meta property="og:title" content={displayData.SEO.TitreOnglet} />
                <meta property="og:description" content={displayData.SEO.Description} />
                <meta property="og:image" content={baseStrapiURL + displayData.SEO.PhotoReseauxSociaux_1200x630.url} />
                <meta property="og:url" content={displayData.Slug === null ? baseURL : baseURL + '/' + displayData.Slug} />
                <meta property="og:type" content="website" />

                {/* Twitter Cards */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={displayData.SEO.TitreOnglet} />
                <meta name="twitter:description" content={displayData.SEO.Description} />
                <meta name="twitter:image" content={baseStrapiURL + displayData.SEO.PhotoReseauxSociaux_1200x630.url} />
                <meta name="twitter:url" content={displayData.Slug === null ? baseURL : baseURL + '/' + displayData.Slug} />

                <title>{displayData.SEO.TitreOnglet}</title>
                <meta name="description" content={displayData.SEO.Description} />
                <link
                    rel="preload"
                    as="image"
                    href="/assets/about/background.jpg"
                    fetchPriority="high"
                />
                <link
                    rel="preload"
                    as="image"
                    href="/assets/about/background.webp"
                    fetchPriority="high"
                />
            </Helmet>
            <TitlePage
                picture={displayData.TitrePage_section.Photo}
                title1={displayData.TitrePage_section.Titre1}
                font1={displayData.TitrePage_section.Typographie1 === 'Great Vibes' ? "handwrite-title" : "classic-title"}
                title2={displayData.TitrePage_section.Titre2}
                font2={displayData.TitrePage_section.Typographie2 === 'Great Vibes' ? "handwrite-title" : "classic-title"}
            />
            <div className="content">
                <Introduction strapiData={{Intro_section: displayData.Intro_section, Part1_section: displayData.Part1_section, Part2_section: displayData.Part2_section, Part3_section: displayData.Part3_section}} />
                <Methodology strapiData={displayData.Part4_section} />
                <Support strapiData={displayData.Workshops_section} />
            </div>
        </div>
    );
};

export default AboutPage;